import Spinner from "../Spinner/Spinner";

 
export default function HonariButton({children , className ,loading=false, disabled=false ,onClick} )
{
    return(<>
    <button onClick={onClick} disabled={disabled || loading} className={`bg-honari-blue text-white rounded border px-3 py-2  disabled:cursor-not-allowed disabled:bg-opacity-50  ${className}`}>
        {loading?
            <div className={"flex gap-x-5 justify-center"}>
                <span>صبر کنید</span>
                <Spinner className={"w-6 h-6"}/>
            </div>
            : children}
    </button>
    </>)
}
